module.exports = __webpack_public_path__ + "img/LUN.59f5821b.svg";